import { render, staticRenderFns } from "./PageBarquettage.vue?vue&type=template&id=143295f0&"
import script from "./PageBarquettage.vue?vue&type=script&lang=js&"
export * from "./PageBarquettage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports